import { FC } from 'react';
interface Dictionary {
  [key: string]: string;
}

const getButtonLabel = (
  checkoutSteps: string[] | undefined,
  currentStep: string
) => {
  if (!checkoutSteps) {
    return '';
  }
  const dictionary: Dictionary = {
    delivery: 'Continue to Shipping method',
    payment: 'Continue to Payment',
    confirm: 'Continue to Order Review',
    complete: 'Continue to Order Review',
  };
  const index: number = checkoutSteps.indexOf(currentStep);

  return dictionary[checkoutSteps[index + 1]];
};

export const findSerialNumber = (
  checkoutSteps: string[],
  currentStep: string
) => {
  return checkoutSteps.indexOf(currentStep) + 1;
};

export default getButtonLabel;
